import { Entity } from '@backstage/catalog-model';

import { Tenant, TenantSpec } from '../types';

export const buildFormData = (tenant?: Tenant, entity?: Entity) => {
  if (!tenant || !entity) {
    return {};
  }
  const entityTenantSpec = entity.spec?.tenant as TenantSpec;
  const quota =
    tenant?.resourceQuota ?? entityTenantSpec?.tenantResourceQuota ?? {};
  return {
    tenantName: entity.metadata.name,
    stage: tenant?.stage ?? entityTenantSpec.stage ?? '',
    tier: tenant?.tier ?? entityTenantSpec.tier ?? '',
    tenantId: tenant?.id ?? entityTenantSpec.id ?? '',
    ownerObjectId:
      tenant?.ownerObjectId ?? entityTenantSpec.ownerObjectId ?? '',
    clusterId: tenant?.clusterId ?? entityTenantSpec.clusterId ?? '',
    clusterSelection: {
      clusterId: tenant?.clusterId ?? entityTenantSpec.clusterId ?? '',
      tier: tenant?.tier ?? entityTenantSpec.tier ?? '',
      nodeGroups: tenant?.nodeGroups ?? entityTenantSpec.nodeGroups ?? [],
    },
    application: tenant?.applicationId ?? entityTenantSpec.applicationId ?? '',
    cabInform: entityTenantSpec.cabInform ?? false,
    securityObjectIds:
      tenant?.securityObjectIds ?? entityTenantSpec.securityObjectIds ?? [],
    pimEnabled: tenant?.pimEnabled ?? false,
    slackChannel: tenant?.slackChannel ?? entityTenantSpec.slackChannel ?? '',
    namespaceQuota: String(
      tenant?.namespaceQuota ?? entityTenantSpec.namespaceQuota ?? 3,
    ),
    cpuRequest: String(quota.cpuRequest ?? 4000),
    cpuLimit: String(quota.cpuLimit ?? 4000),
    memoryRequest: String(quota.memoryRequest ?? 8192),
    memoryLimit: String(quota.memoryLimit ?? 8192),
    gitopsConfig: {
      enabled: !!tenant?.argocdProject,
      gitRepos: tenant?.argocdProject?.repositories ?? [],
      rootPath: tenant?.argocdProject?.rootPath ?? '',
      helmRepos: tenant?.argocdProject?.helmRepositories ?? [],
    },
  };
};
